import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { CustomBreadcrumbType } from './types/CustomBreadcrumbType';
import './CustomBreadcrumb.css';

/**
 * CustomBreadcrumb Component
 * A clean, professional breadcrumb navigation for enterprise dashboards.
 */
export const CustomBreadcrumb: React.FC<CustomBreadcrumbType> = ({
    items,
    separator = <ChevronRight size={14} />,
    className = '',
}) => {
    return (
        <nav aria-label="Breadcrumb" className={`custom-breadcrumb ${className}`}>
            <ol className="custom-breadcrumb__list">
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return (
                        <li key={index} className="custom-breadcrumb__item">
                            {index > 0 && (
                                <span className="custom-breadcrumb__separator" aria-hidden="true">
                                    {separator}
                                </span>
                            )}

                            {item.path && !isLast ? (
                                <Link to={item.path} className="custom-breadcrumb__link">
                                    {item.icon && <span className="custom-breadcrumb__icon">{item.icon}</span>}
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={`custom-breadcrumb__text ${isLast ? 'custom-breadcrumb__text--active' : ''}`}>
                                    {item.icon && <span className="custom-breadcrumb__icon">{item.icon}</span>}
                                    {item.label}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
